module.exports = __webpack_public_path__ + "static/media/img1-2.9ed31293.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/maiz/biosense/diff/img1-2.png
// module id = 1698
// module chunks = 3